import React from 'react'
import { SelectV5 } from '@pinchenterprisesnpm/friday-ui'
import { customSelectStyles, FloatingLabel, SelectWrapper } from './custom-async-select.styles'
import { ICustomAsyncSelectProps } from './custom-async-select.types'

export const CustomAsyncSelect = <T,>({
  label,
  value,
  onFocus,
  onBlur,
  isDisabled,
  menuPlacement,
  ptValueContainer,
  ...props
}: ICustomAsyncSelectProps<T>) => {
  const [isFocused, setIsFocused] = React.useState(false)

  const handleFocus = () => {
    setIsFocused(true)
    onFocus?.()
  }

  const handleBlur = () => {
    setIsFocused(false)
    onBlur?.()
  }

  return (
    <SelectWrapper>
      <SelectV5
        {...props}
        value={value}
        onFocus={handleFocus}
        onBlur={handleBlur}
        selectStyles={customSelectStyles(ptValueContainer)}
        isDisabled={isDisabled}
        menuPlacement={menuPlacement}
      />
      <FloatingLabel hasValue={!!value} isFocused={isFocused}>
        {label}
      </FloatingLabel>
    </SelectWrapper>
  )
}
